import script from "./AdminCommentsSection.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdminCommentsSection.vue?vue&type=script&lang=ts&setup=true"

import "./AdminCommentsSection.vue?vue&type=style&index=0&id=482ef487&lang=scss&scoped=true"

import exportComponent from "/Users/lyon/Desktop/Work s2j/app-rentalcar-project/admin-v3 2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-482ef487"]])

export default __exports__